import { MotionDiv } from '@/components/element/MotionDiv';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { SalesOrderLogic, TeamMemberLogic } from '@/hooks/api/models/logics';
import { SimpleTextFormatWithLink } from '@/components/element/SimpleTextFormat';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';

export const ProjectInfo = () => {
  const location = useLocation();
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();
  const [editable, setEditable] = useState<boolean>(false);

  useEffect(() => {
    if (task) {
      setEditable(SalesOrderLogic.canUpdate(_t_!, task.sales_order, me!));
    }
  }, [task]);

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">プロジェクト概要</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold me-3">プロジェクト名</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark text-truncate">
            {editable ? (
              <Link
                to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${sales_order_id}`}
                className="text-decoration-underline"
              >
                {task!.sales_order.name}
              </Link>
            ) : (
              <>{task!.sales_order.name}</>
            )}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs font-weight-bold pe-2">チーム名</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">{task!.sales_order.team_outline.name}</div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">プロジェクト担当者</div>
          <div className="d-flex align-items-center">
            <img
              src={task!.sales_order.user.user_account.icon_file_url}
              className="avatar avatar-xs rounded-circle me-1"
            />
            <div className="font-weight-bold px-0 text-sm text-dark">{task!.sales_order.user.user_account.name}</div>
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">取引先</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.sales_order.business_partner.display_name}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">代理店</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.sales_order.agency?.display_name}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">請求先</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.sales_order.billing_target.label}
          </div>
        </div>
      </div>
    </MotionDiv>
  );
};
